var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#008C23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7667 8.09167C19.6 7.6 19.1333 7.25 18.5833 7.25H9.41667C8.86667 7.25 8.40833 7.6 8.23333 8.09167L6.5 13.0833V19.75C6.5 20.2083 6.875 20.5833 7.33333 20.5833H8.16667C8.625 20.5833 9 20.2083 9 19.75V18.9167H19V19.75C19 20.2083 19.375 20.5833 19.8333 20.5833H20.6667C21.125 20.5833 21.5 20.2083 21.5 19.75V13.0833L19.7667 8.09167ZM9.41667 16.4167C8.725 16.4167 8.16667 15.8583 8.16667 15.1667C8.16667 14.475 8.725 13.9167 9.41667 13.9167C10.1083 13.9167 10.6667 14.475 10.6667 15.1667C10.6667 15.8583 10.1083 16.4167 9.41667 16.4167ZM18.5833 16.4167C17.8917 16.4167 17.3333 15.8583 17.3333 15.1667C17.3333 14.475 17.8917 13.9167 18.5833 13.9167C19.275 13.9167 19.8333 14.475 19.8333 15.1667C19.8333 15.8583 19.275 16.4167 18.5833 16.4167ZM8.16667 12.25L9.41667 8.5H18.5833L19.8333 12.25H8.16667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveVehicle);
export default __webpack_public_path__ + "static/media/active_vehicle.23ff808bdf983f5f9fb7f6de84f4ff8d.svg";
export { ForwardRef as ReactComponent };